import React from "react";

// Style \\
import "../../assets/styles/sections/contactPageHero.scss";

const ContactPageHero = () => {
  return (
    <section className="contactPageHero">
      <div className="contactPageHero_bg">
        <div className="container">
          <div className="contactPageHero_items">
            <div className="title">
              <p>Home / Contact</p>
              <h2>Our Contacts</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPageHero;
